<div
  *ngIf="
    nomeFormulario?.get(nomeCampo)?.invalid &&
    ((campoTocado && nomeFormulario?.get(nomeCampo)?.touched) || isFormSubmited) &&
    nomeFormulario?.get(nomeCampo)?.errors?.['required']
  "
  class="invalid-feedback d-block">
  Campo é obrigatório!
</div>

<div
  *ngIf="nomeFormulario?.get(nomeCampo)?.touched && nomeFormulario?.get(nomeCampo)?.errors?.['maxlength']"
  class="invalid-feedback d-block">
  Campo não pode ter mais que {{ maxLength }} caracteres!
</div>
<div
  *ngIf="nomeFormulario?.get(nomeCampo)?.touched && nomeFormulario?.get(nomeCampo)?.errors?.['minlength']"
  class="invalid-feedback d-block">
  Campo não pode ter menos que {{ minLength }} caracteres!
</div>
<div
  *ngIf="nomeFormulario?.get(nomeCampo)?.touched && nomeFormulario?.get(nomeCampo)?.errors?.['validaCPF']"
  class="invalid-feedback d-block">
  Campo CPF Inválido!
</div>
